import { Injectable } from '@angular/core';
import { CommentService } from '../comment/comment.service';
import { v5 as uuidv5 } from 'uuid';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ActivityHistoryService {
    private historyCreatedSubject = new Subject<void>();
    historyCreated$ = this.historyCreatedSubject.asObservable();

    constructor(
        private commentService: CommentService,

    ) { }

    createHistory(id: string, content: any, medias?: any) {
        const NAMESPACE = uuidv5.DNS;
        const historyId = uuidv5(`${id}-history`, NAMESPACE);

        const body: any = {
            object_id: historyId,
            parent_id: historyId,
            object_type: 'POST',
            content: JSON.stringify(content),
            message_ranges: [],
            medias,
            language: 'vi',
            preview_data: null,
            owner_type: 'USER',
        }
        this.commentService
            .create(body)
            .subscribe({
                next: (response) => {
                    this.historyCreatedSubject.next(response?.data);
                }
            });
    }
}
